import { generateMqttRandomClientId } from 'utils/generateMqttRandomClientId'
import { LOGIN_SUCCESS } from '../home/HomeConstants'
import {
  SET_CONNECTION,
  REFRESH_TOKEN_SUCCESS,
  INTERNAL_SERVER_ERROR,
  NETWORK_ERROR,
  CLEAR_INTERNAL_SERVER_ERROR,
  CLEAR_500_ERROR,
  LOGOUT,
} from './AuthConstants'

const initialState = {
  accessToken: '',
  isInternalError: false,
  isNetworkError: false,
  loggedIn: false,
  isConnected: true,
  serverErrorMessage: '',
  mqttRandomClientId: '',
}

export const authReducer = (state = initialState, action = {}) => {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_CONNECTION:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isConnected: action.payload,
      }
    case LOGIN_SUCCESS:
    case REFRESH_TOKEN_SUCCESS:
      if (!state.mqttRandomClientId) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        const mqttRandomClientId = action.extraData?.mqttRandomClientId || generateMqttRandomClientId()
        return {
          ...state,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          accessToken: action.payload.AccessToken,
          loggedIn: true,
          mqttRandomClientId,
        }
      }
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        accessToken: action.payload.AccessToken,
        loggedIn: true,
      }
    case INTERNAL_SERVER_ERROR:
      return {
        ...state,
        isInternalError: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        serverErrorMessage: action.payload,
      }
    case NETWORK_ERROR:
      return {
        ...state,
        isNetworkError: true,
      }
    case CLEAR_INTERNAL_SERVER_ERROR:
      return {
        ...state,
        isInternalError: false,
        serverErrorMessage: '',
      }
    case CLEAR_500_ERROR:
      return {
        ...state,
        isNetworkError: false,
      }
    case LOGOUT: {
      return {
        ...initialState,
      }
    }
    default:
      return state
  }
}
